<template>
  <div>
    <Main
      ref="main"
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      :prohibit="prohibit"
      :designDisabled="designDisabled"
      :operateDisabled="operateDisabled"
      :tablePage="page"
      @reload="reload"
      @openEditSkuDialog="openEditSkuDialog"
      @checkbox-change="(data) => (checkedRows = data)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        :disabled="disabled"
        :prohibit="prohibit"
      >
        <b-col cols="7" style="padding-left: 0px;">
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="openAddPlan"
            v-if="!disabled && !prohibit"
          >
            {{ $l('btn_text_select_product') || '选择产品' }}
          </b-button>

          <el-badge
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="clearable-button"
            :class="{ clearable: !!checkedRowCount }"
            v-if="!disabled && !prohibit"
          >
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              :disabled="!checkedRowCount"
              @click="updateCustoms"
              v-if="!disabled && !prohibit"
            >
              {{ $l('btn_text_batch_modify') || '批量修改' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </el-badge>
        </b-col>
      </PageHeader>
      <template #toolbar_btn>
        <SortFieldsPopover
          v-model="sortFields"
          funcListName="amzFirstDemandDetailList"
          style="margin-right: 0.8em;"
          @change="reload"
        />
      </template>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </Main>
    <ChooseAmzSku
      :visible.sync="chooseAmzSkuVisible"
      :amzSkuStatus="['P']"
      :isVcList="isVcList"
      multiple
      @confirm="skuConfirm"
    />

    <AddFirstOrder
      v-if="addPlanOptions.visible"
      :visible.sync="addPlanOptions.visible"
      :title="addPlanOptions.title"
      :amzFirstDemandCode="amzFirstDemandCode"
      :multiple="false"
      @reload="close"
    ></AddFirstOrder>

    <EditSku
      :visible.sync="editSkuOpts.visible"
      :disabled="editSkuOpts.disabled"
      :planningDisabled="editSkuOpts.planningDisabled"
      :title="editSkuOpts.title"
      :amzFirstDemandDetailCode="editSkuOpts.amzFirstDemandDetailCode"
      @reload="reload"
    />
    <BatchModify
      :visible="showCustoms"
      v-if="showCustoms"
      @close="showCustoms = false"
      @batchSave="batchSave"
    />
  </div>
</template>
<script>
import Main from './main.vue'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import ChooseAmzSku from '@/views/ecom/components/choose-amz-sku'
import EditSku from '../edit-sku'
import AddFirstOrder from '../add-first-order'
import BatchModify from '../batch-modify'
import SortFieldsPopover from '@/views/ecom/components/sort-fields-popover'
export default {
  mixins: [BaseTable, EditLoading],
  components: {
    Main,
    PageHeader,
    ChooseAmzSku,
    AddFirstOrder,
    EditSku,
    SortFieldsPopover,
    BatchModify,
  },
  props: {
    disabled: { type: Boolean, default: false },
    prohibit: { type: Boolean, default: false },
    designDisabled: { type: Boolean, default: false },
    operateDisabled: { type: Boolean, default: false },
    amzFirstDemandCode: { type: String, default: '' },
    isVcList: { type: Array, default: () => [] },
  },
  data() {
    return {
      usePage: true,
      loading: false,
      showCustoms: false,
      checkedRows: [],
      chooseAmzSkuVisible: false,
      addPlanOptions: {
        visible: false,
      },
      editSkuOpts: {
        visible: false,
        amzFirstDemandDetailCode: '',
      },
      sortFields: [],
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData(form) {
      if (!this.amzFirstDemandCode) return
      this.loading = true
      const res = await this.$api
        .ecomAmzFirstDemandDetailPageListApi({
          amzFirstDemandCode: this.amzFirstDemandCode,
          ...form,
          ...this.page,
          sortFields: this.sortFields,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.setData(res)
    },

    openAddPlan() {
      if (!this.amzFirstDemandCode) {
        this.$message.warning('请先保存主信息')
      } else {
        this.addPlanOptions.visible = true
        this.addPlanOptions.title =
          this.$l('btn_text_select_product') || '选择产品'
      }
    },
    updateCustoms() {
      this.showCustoms = true
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
    async batchSave(params) {
      const amzFirstDemandDetailCodes = this.checkedRows.map(
        (item) => item.amzFirstDemandDetailCode
      )
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzFirstDemandDetailBatchModifyApi({
          ...params,
          amzFirstDemandDetailCodes,
          amzFirstDemandCode: this.amzFirstDemandCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.showCustoms = false
      this.clearCheckboxRow()
      this.reload()
    },
    openEditSkuDialog({ pageType, code = '' }) {
      const types = {
        planningEditor: this.$l('dialog_title_planning_edit') || '企划编辑产品',
        operationsEditor:
          this.$l('dialog_title_operations_edit') || '运营编辑产品',
        detail: this.$l('dialog_title_product_details') || '产品详情',
      }

      this.editSkuOpts = {
        visible: true,
        title: types[pageType],
        amzFirstDemandDetailCode: code,
        disabled: pageType === 'detail',
        planningDisabled: pageType === 'planningEditor',
      }
    },

    async skuConfirm(data) {
      if (!data || !data.length) return

      if (this.loadingOpen()) return
      this.$api
        .ecomAmzFirstDemandDetailAddSaveApi({
          amzFirstDemandCode: this.amzFirstDemandCode,
          details: data,
        })
        .then((res) => {
          this.loading = false
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.close()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    async spuConfirm({ data }) {
      if (!data || !data.length) return
      const amzFirstDemandSpuCodeList = data.map((item) => {
        return item.amzFirstDemandSpuCode
      })
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .ecomAmzFirstDemandSpuDelApi({
            amzFirstDemandCode: this.amzFirstDemandCode,
            amzFirstDemandSpuCodeList,
          })
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.close()
          })
      })
    },

    close() {
      this.chooseAmzSkuVisible = false
      this.clearCheckboxRow()
      this.getData()
      this.$emit('reset')
    },

    validate() {
      return this.$refs.main.validate()
    },
    getTableData() {
      return this.$refs.main.getTableData()
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 20px;
  margin-top: 3px;
}
.tag_div {
  border: 1px solid #dcdfe6;
  padding: 0px 7px 7px 7px;
  border-radius: 4px;
  min-height: 50px;
}
</style>
